import { FooterConfig } from '@tenants/types/tenant';
import {
  getRootDomainUrl,
  getRootDomainUrlWithPath,
  getSubDomainUrl,
  RootDomain,
} from 'constants/domains';

export function createFooterConfig(rootDomain: RootDomain): FooterConfig {
  const footerConfig = {
    footerColumns: {
      column1: [
        {
          label: {
            key: '',
            defaultValue: 'Explore eXp',
          },
          link: getRootDomainUrl(rootDomain),
          isAnchor: true,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Find an Agent',
          },
          link: '/agents-search',
          isAnchor: true,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Join eXp',
          },
          link: getSubDomainUrl(rootDomain, 'join'),
          isAnchor: true,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Investor Relations',
          },
          link: 'https://expworldholdings.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Company Careers',
          },
          link: 'https://expworldholdings.com/careers/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Home Guides',
          },
          link: getRootDomainUrlWithPath(rootDomain, '/guides'),
          isAnchor: true,
          target: '_blank',
        },
      ],
      column2: [
        {
          label: {
            key: '',
            defaultValue: 'eXp Life',
          },
          link: getSubDomainUrl(rootDomain, 'life'),
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Zoocasa',
          },
          link: 'https://zoocasa.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'SUCCESS',
          },
          link: 'https://www.success.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'eXp Revenos',
          },
          link: 'https://revenos.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'eXp Commercial',
          },
          link: getSubDomainUrl(rootDomain, 'www'),
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'eXp Luxury',
          },
          link: 'https://expluxury.com/?tl=en',
          isAnchor: false,
          target: 'blank',
        },
      ],
      column3: [
        {
          label: {
            key: '',
            defaultValue: 'Terms and Conditions',
          },
          link: 'https://expworldholdings.com/terms-of-service/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Privacy Rights Request',
          },
          link: 'https://submit-irm.trustarc.com/services/validation/e6d7516d-df9c-4404-bd9f-21a2f0d2a6a4/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Privacy Policy',
          },
          link: 'https://expworldholdings.com/privacy-policy/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Cookie Policy',
          },
          link: 'https://expworldholdings.com/cookie-policy/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Brand Guidelines',
          },
          link: 'https://join.exprealty.com/brand/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Help',
          },
          link: 'https://searchhelp.exprealty.com/hc/en-us/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Sitemap',
          },
          link: '/sitemap',
          isAnchor: true,
          target: '_blank',
        },
      ],
      bottom: [
        [
          {
            label: {
              key: '',
              defaultValue: '© 2024 eXp Realty. eXp World Holdings, Inc. All Rights Reserved.',
            },
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: ' ',
            },
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: 'DMCA Notice',
            },
            link: '/dmca',
            target: '_blank',
            isAnchor: true,
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: 'This site is protected by reCAPTCHA and the Google ',
            },
          },
          {
            label: {
              key: '',
              defaultValue: 'Privacy Policy',
            },
            link: 'https://policies.google.com/privacy',
            target: '_blank',
            isAnchor: true,
          },
          {
            label: {
              key: '',
              defaultValue: ' and ',
            },
          },
          {
            label: {
              key: '',
              defaultValue: 'Terms of Service ',
            },
            link: 'https://policies.google.com/terms',
            target: '_blank',
            isAnchor: true,
          },
          {
            label: {
              key: '',
              defaultValue: 'apply.',
            },
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: 'Fair Housing and Reasonable Accommodations',
            },
            link: '/fair-housing-and-reasonable-accommodations',
            target: '_blank',
            isAnchor: true,
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: 'MLS Compliance Statements',
            },
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: 'Karen Richards – Designated Managing Broker, Broker Operations – TX',
            },
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: 'Texas Real Estate Commission information about brokerage services',
            },
            link: 'https://drive.google.com/file/d/1NMjX7L_BEHJWLQjUXnvf2Ivou4s8sTuA/view',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: 'Texas Real Estate Commission Consumer Protection Notice',
            },
            link: 'https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-4-1_1.pdf',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: 'eXp Realty® is committed to adhering to the guidelines of The New York State Fair Housing Regulations. ',
            },
          },
          {
            label: {
              key: '',
              defaultValue: 'The Fair Housing Notice',
            },
            link: 'https://dos.ny.gov/fair-housing',
            isAnchor: true,
            target: '_blank',
          },
          {
            label: {
              key: '',
              defaultValue: ' →',
            },
            link: 'https://dos.ny.gov/system/files/documents/2021/08/fairhousingnotice.pdf',
            target: '_blank',
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: '*Standardized Operating Procedure for Purchasers of Real Estate Pursuant to Real Property Law 442-H. ',
            },
          },
          {
            label: {
              key: '',
              defaultValue: 'Learn More',
            },
            link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
            isAnchor: true,
            target: '_blank',
          },
          {
            label: {
              key: '',
              defaultValue: ' →',
            },
            link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
            target: '_blank',
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: ' ',
            },
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: 'eXp Realty of California, Inc. | CA DRE# 01878277 | Deborah Penny – Designated Broker',
            },
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: 'eXp Realty of Southern California, Inc. | CA DRE# 02187306 | Gina Saad – Designated Broker',
            },
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: 'eXp Realty of Greater Los Angeles, Inc. | CA DRE# 01828532 | Justin DeCesare – Designated Broker',
            },
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: 'eXp Realty of Northern California, Inc. | CA DRE# 01951343 | Ryan Rosas – Designated Broker',
            },
          },
        ],
      ],
      joinUsLink: 'https://join.exprealty.com/',
      footerImageData: {
        src: '/next/assets/images/exp-footer-pic-in-service.png',
        alt: {
          key: '',
          defaultValue: 'A group of people at an event are laughing and cheering, with one man enthusiastically greeting a seated couple in the front row.',
        },
      },
    },
    showAccessibilityLink: false,
  };

  return footerConfig;
}